module.exports = __webpack_public_path__ + "static/media/xaverian-brothers.01de7935.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/xaverian-brothers.jpg
// module id = 638
// module chunks = 0